// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-standby {
  position: absolute;
  width: 100%;
  height: 100vh;
  z-index: 1;
  transition: 0.5s ease all;
  opacity: 0;
  pointer-events: none;
}
app-standby.show {
  opacity: 1;
  pointer-events: unset;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;AACJ;AAAI;EACI,UAAA;EACA,qBAAA;AAER","sourcesContent":["app-standby{\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100vh;\r\n    z-index: 1;\r\n    transition: .5s ease all;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n    &.show{\r\n        opacity: 1;\r\n        pointer-events: unset;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
